<template lang="pug">
  .wrap
    nav.sidenav
      ul
        li.item
          div(v-for='item in menuItems' :key='item.label')
            router-link(@click.native='closeSidebar' v-if='item.routeName' :to="{ name: item.routeName }" exact)
              icon.icon(:name='item.icon')
              | {{ item.label }}
            a(v-else)
              icon.icon(:name='item.icon')
              | {{ item.label }}
            ul
              router-link.item(@click.native='closeSidebar' v-for='route, sub_item in item.subNav' :key='sub_item' tag="li" :to="{ name: route }" exact)
                a {{ sub_item }}

</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      menuItems: [
        {
          label: "Dashboard",
          icon: "home",
          routeName: "superAdmin:dashboard"
        },
        {
          label: "Clients",
          icon: "users",
          routeName: "superAdmin:companyList"
        }
      ]
    };
  },
  computed: {
    ...mapGetters("ui", ["sidenavCollapsed"]),
    screenLessThan1100() {
      return this.$mq.resize && this.$mq.below(1100);
    }
  },
  methods: {
    ...mapMutations("ui", ["toggleSidenav"]),
    closeSidebar() {
      if (this.screenLessThan1100) {
        this.toggleSidenav();
      }
    }
  }
};
</script>

<style scoped lang="scss">
.wrap {
  a {
    color: white;
    text-decoration: none;
  }
}

.item {
  border-bottom: 1px solid #475669;
  display: flex;
  flex-direction: column;
  a {
    padding: 15px;
    display: flex;
    align-items: center;
    font-family: "gilroyextrabold";
    font-weight: bold;
    transition: background 0.2s;
    &:hover {
      background: #475669;
    }
  }
}

.icon {
  width: 20px;
  margin-right: 10px;
}
</style>
